export default __webpack_public_path__ + "static/media/pic4.3e5376e4.jpg";